import { render, staticRenderFns } from "./SmsConfigVoip.vue?vue&type=template&id=63cce72e&"
import script from "./SmsConfigVoip.vue?vue&type=script&lang=js&"
export * from "./SmsConfigVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports